import { render, staticRenderFns } from "./VideoPlace.vue?vue&type=template&id=42fe3350&scoped=true"
import script from "./VideoPlace.vue?vue&type=script&lang=js"
export * from "./VideoPlace.vue?vue&type=script&lang=js"
import style0 from "./VideoPlace.vue?vue&type=style&index=0&id=42fe3350&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fe3350",
  null
  
)

export default component.exports